import { baseEatingSupport, baseK0520Clinical, baseOralIntakeClinical, basePocNutrition, baseWeightClinical, } from '../validations/shared/nutrition';
import { baseSnnNutrition } from '../validations/snn';
import { getFromRegistry } from './types';
const nutritionSubsections = {
    nutritionalApproaches: baseSnnNutrition.shape.nutritionalApproaches.unwrap(),
    weightClinical: baseWeightClinical,
    appetite: baseOralIntakeClinical.shape.appetite.unwrap(),
    swallowing: baseOralIntakeClinical.shape.swallowing.unwrap(),
    factorsAffecting: baseOralIntakeClinical.shape.factorsAffecting.unwrap(),
    adaptiveEquipment: baseEatingSupport.shape.adaptiveEquipment.unwrap(),
    mealAssistance: baseEatingSupport.shape.mealAssistance.unwrap(),
    pocNutrition: basePocNutrition,
    parenteral: baseK0520Clinical.shape.parenteral.unwrap(),
    feedingTube: baseK0520Clinical.shape.feedingTube.unwrap(),
    mechanicallyAlteredDiet: baseK0520Clinical.shape.mechanicallyAlteredDiet.unwrap(),
    therapeuticDiet: baseK0520Clinical.shape.therapeuticDiet.unwrap(),
};
export const nutritionSubsectionLabels = Object.fromEntries(Object.keys(nutritionSubsections).map((key) => [
    key,
    getFromRegistry(nutritionSubsections[key]),
]));
const parenteral = baseK0520Clinical.shape.parenteral.unwrap().shape;
const feedingTube = baseK0520Clinical.shape.feedingTube.unwrap().shape;
const mechanicallyAlteredDiet = baseK0520Clinical.shape.mechanicallyAlteredDiet.unwrap().shape;
const therapeuticDiet = baseK0520Clinical.shape.therapeuticDiet.unwrap().shape;
const appetite = baseOralIntakeClinical.shape.appetite.unwrap().shape;
const swallowing = baseOralIntakeClinical.shape.swallowing.unwrap().shape;
const factorsAffecting = baseOralIntakeClinical.shape.factorsAffecting.unwrap().shape;
const adaptiveEquipment = baseEatingSupport.shape.adaptiveEquipment.unwrap().shape;
const mealAssistance = baseEatingSupport.shape.mealAssistance.unwrap().shape;
export const nutritionalApproachesFields = [
    { key: 'approaches', field: baseSnnNutrition.shape.nutritionalApproaches, variant: 'tags' },
];
export const weightClinicalFields = [
    { key: 'currentHeight', field: baseWeightClinical.shape.currentHeight },
    { key: 'currentWeight', field: baseWeightClinical.shape.currentWeight },
    { key: 'heightSource', field: baseWeightClinical.shape.heightSource },
    { key: 'weightSource', field: baseWeightClinical.shape.weightSource },
    { key: 'previousWeight', field: baseWeightClinical.shape.previousWeight },
    { key: 'previousWeightDate', field: baseWeightClinical.shape.previousWeightDate, formatDate: true },
    { key: 'previousWeightSource', field: baseWeightClinical.shape.previousWeightSource },
    { key: 'weightChange', field: baseWeightClinical.shape.weightChange },
    { key: 'weightChangeAmount', field: baseWeightClinical.shape.weightChangeAmount },
    { key: 'weightChangePeriod', field: baseWeightClinical.shape.weightChangePeriod },
    { key: 'weightChangePeriodOther', field: baseWeightClinical.shape.weightChangePeriodOther },
    { key: 'changeIntentional', field: baseWeightClinical.shape.changeIntentional },
    { key: 'weightLossCauses', field: baseWeightClinical.shape.weightLossCauses, variant: 'tags' },
    { key: 'weightGainCauses', field: baseWeightClinical.shape.weightGainCauses, variant: 'tags' },
    { key: 'weightGainSymptoms', field: baseWeightClinical.shape.weightGainSymptoms, variant: 'tags' },
    { key: 'monitoringReasons', field: baseWeightClinical.shape.monitoringReasons, variant: 'tags' },
    { key: 'clinicalNarrative', field: baseWeightClinical.shape.clinicalNarrative },
];
export const oralIntakeAppetiteFields = [
    { key: 'currentAppetite', field: appetite.currentAppetite },
    { key: 'appetiteChange', field: appetite.appetiteChange },
    { key: 'appetiteChangeSince', field: appetite.appetiteChangeSince, formatDate: true },
    { key: 'appetiteChangeCause', field: appetite.appetiteChangeCause },
    { key: 'mealsPerDay', field: appetite.mealsPerDay },
    { key: 'typicalIntake', field: appetite.typicalIntake },
    { key: 'fluidIntake', field: appetite.fluidIntake },
];
export const oralIntakeSwallowingFields = [
    { key: 'swallowingDifficulty', field: swallowing.swallowingDifficulty, variant: 'tags' },
    { key: 'aspirationRiskSigns', field: swallowing.aspirationRiskSigns, variant: 'tags' },
    { key: 'aspirationPneumoniaHistory', field: swallowing.aspirationPneumoniaHistory },
    { key: 'aspirationPneumoniaWhen', field: swallowing.aspirationPneumoniaWhen },
    { key: 'aspirationPneumoniaEpisodes', field: swallowing.aspirationPneumoniaEpisodes },
    { key: 'slpEvaluation', field: swallowing.slpEvaluation },
    { key: 'slpEvaluationDate', field: swallowing.slpEvaluationDate, formatDate: true },
];
export const oralIntakeFactorsFields = [
    { key: 'physical', field: factorsAffecting.physical, variant: 'tags' },
    { key: 'sensory', field: factorsAffecting.sensory, variant: 'tags' },
    { key: 'cognitivePsych', field: factorsAffecting.cognitivePsych, variant: 'tags' },
    { key: 'functional', field: factorsAffecting.functional, variant: 'tags' },
    { key: 'medicationsAffecting', field: factorsAffecting.medicationsAffecting },
    { key: 'medicationsAffectingDetails', field: factorsAffecting.medicationsAffectingDetails },
    { key: 'socialEconomic', field: factorsAffecting.socialEconomic, variant: 'tags' },
];
export const eatingSupportAdaptiveFields = [
    { key: 'equipmentInUse', field: adaptiveEquipment.equipmentInUse, variant: 'tags' },
    { key: 'equipmentInUseOther', field: adaptiveEquipment.equipmentInUseOther },
    { key: 'equipmentNeeded', field: adaptiveEquipment.equipmentNeeded, variant: 'tags' },
    { key: 'equipmentNeededList', field: adaptiveEquipment.equipmentNeededList },
];
export const eatingSupportMealFields = [
    { key: 'assistanceProvider', field: mealAssistance.assistanceProvider, variant: 'tags' },
    { key: 'helpType', field: mealAssistance.helpType, variant: 'tags' },
    { key: 'caregiverTrainingNeeded', field: mealAssistance.caregiverTrainingNeeded },
    { key: 'caregiverTrainingTopics', field: mealAssistance.caregiverTrainingTopics, variant: 'tags' },
    { key: 'caregiverTrainingOther', field: mealAssistance.caregiverTrainingOther },
];
export const pocNutritionFields = [
    { key: 'skilledJustification', field: basePocNutrition.shape.skilledJustification, variant: 'list' },
];
export const k0520ParenteralFields = [
    { key: 'type', field: parenteral.type, variant: 'tags' },
    { key: 'access', field: parenteral.access, variant: 'tags' },
    { key: 'formula', field: parenteral.formula },
    { key: 'rate', field: parenteral.rate },
    { key: 'hoursPerDay', field: parenteral.hoursPerDay },
    { key: 'caloriesPerDay', field: parenteral.caloriesPerDay },
    { key: 'monitoring', field: parenteral.monitoring, variant: 'tags' },
    { key: 'monitoringFrequency', field: parenteral.monitoringFrequency },
    { key: 'complications', field: parenteral.complications, variant: 'tags' },
];
export const k0520FeedingTubeFields = [
    { key: 'tubeType', field: feedingTube.tubeType, variant: 'tags' },
    { key: 'size', field: feedingTube.size },
    { key: 'placedDate', field: feedingTube.placedDate, formatDate: true },
    { key: 'formula', field: feedingTube.formula },
    { key: 'rate', field: feedingTube.rate },
    { key: 'method', field: feedingTube.method, variant: 'tags' },
    { key: 'schedule', field: feedingTube.schedule },
    { key: 'totalVolumePerDay', field: feedingTube.totalVolumePerDay },
    { key: 'freeWaterFlushes', field: feedingTube.freeWaterFlushes },
    { key: 'tubeSite', field: feedingTube.tubeSite, variant: 'tags' },
    { key: 'residuals', field: feedingTube.residuals },
    { key: 'residualThreshold', field: feedingTube.residualThreshold },
    { key: 'residualAction', field: feedingTube.residualAction, variant: 'tags' },
    { key: 'patientCompetency', field: feedingTube.patientCompetency },
    { key: 'skilledJustification', field: feedingTube.skilledJustification, variant: 'tags' },
];
export const k0520MechanicallyAlteredDietFields = [
    { key: 'foodTexture', field: mechanicallyAlteredDiet.foodTexture, variant: 'tags' },
    { key: 'liquidConsistency', field: mechanicallyAlteredDiet.liquidConsistency, variant: 'tags' },
    { key: 'reason', field: mechanicallyAlteredDiet.reason, variant: 'tags' },
    { key: 'reasonOther', field: mechanicallyAlteredDiet.reasonOther },
    { key: 'swallowEval', field: mechanicallyAlteredDiet.swallowEval },
    { key: 'swallowEvalDate', field: mechanicallyAlteredDiet.swallowEvalDate, formatDate: true },
    { key: 'dietCompliance', field: mechanicallyAlteredDiet.dietCompliance },
];
export const k0520TherapeuticDietFields = [
    { key: 'dietTypes', field: therapeuticDiet.dietTypes, variant: 'tags' },
    { key: 'carbsPerMeal', field: therapeuticDiet.carbsPerMeal },
    { key: 'sodiumPerDay', field: therapeuticDiet.sodiumPerDay },
    { key: 'fluidRestriction', field: therapeuticDiet.fluidRestriction },
    { key: 'dietTypeOther', field: therapeuticDiet.dietTypeOther },
    { key: 'prescribedBy', field: therapeuticDiet.prescribedBy, variant: 'tags' },
    { key: 'educationProvided', field: therapeuticDiet.educationProvided },
    { key: 'educationDate', field: therapeuticDiet.educationDate, formatDate: true },
    { key: 'dietCompliance', field: therapeuticDiet.dietCompliance },
    { key: 'complianceBarriers', field: therapeuticDiet.complianceBarriers, variant: 'tags' },
    { key: 'skilledJustification', field: therapeuticDiet.skilledJustification, variant: 'tags' },
];
